interface PriceRangeSliderProps {
  min: number;
  max: number;
  step?: number;
  minValue: number;
  maxValue: number;
  onMinChange: (value: number) => void;
  onMaxChange: (value: number) => void;
}

export function PriceRangeSlider({
  min,
  max,
  step = 5,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
}: PriceRangeSliderProps) {
  const range = max - min || 1;
  const minPercent = ((minValue - min) / range) * 100;
  const maxPercent = ((maxValue - min) / range) * 100;
  const minOnTop = minValue >= max - step;

  const handleMinInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    onMinChange(Math.min(Number(e.target.value), maxValue - step));
  };

  const handleMaxInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    onMaxChange(Math.max(Number(e.target.value), minValue + step));
  };

  return (
    <div className="dual-range relative h-4 w-full">
      <div className="absolute top-1/2 left-0 right-0 h-1 -translate-y-1/2 rounded-full bg-champagne-dark" />
      <div
        className="absolute top-1/2 h-1 -translate-y-1/2 rounded-full bg-chocolate"
        style={{ left: `${minPercent}%`, right: `${100 - maxPercent}%` }}
      />
      <input
        type="range"
        aria-label="Preço mínimo"
        min={min}
        max={max}
        step={step}
        value={minValue}
        onChange={handleMinInput}
        className="absolute top-0 left-0 h-4 w-full"
        style={{ zIndex: minOnTop ? 5 : 3 }}
      />
      <input
        type="range"
        aria-label="Preço máximo"
        min={min}
        max={max}
        step={step}
        value={maxValue}
        onChange={handleMaxInput}
        className="absolute top-0 left-0 h-4 w-full"
        style={{ zIndex: 4 }}
      />
    </div>
  );
}
